/**
 * SOURCING: a need still being shopped for — no vendor, price fixed at 0,
 * quotes collected against it. BOOKED: a vendor and price agreed. Only booked
 * lines count toward what is owed.
 */
export var ExpensePhase;
(function (ExpensePhase) {
    ExpensePhase["SOURCING"] = "SOURCING";
    ExpensePhase["BOOKED"] = "BOOKED";
})(ExpensePhase || (ExpensePhase = {}));
/** What the expenses list may be ordered by (server-side). */
export const EXPENSE_LIST_SORTS = [
    'createdAt',
    'dueDate',
    'price',
    'event',
    'vendor',
    'category',
    'status',
    'item',
];
//# sourceMappingURL=expense.js.map